/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePresignedUrlRequest
 */
export interface CreatePresignedUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePresignedUrlRequest
     */
    target: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePresignedUrlRequest
     */
    fileName: string;
}

/**
 * Check if a given object implements the CreatePresignedUrlRequest interface.
 */
export function instanceOfCreatePresignedUrlRequest(value: object): value is CreatePresignedUrlRequest {
    if (!('target' in value) || value['target'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    return true;
}

export function CreatePresignedUrlRequestFromJSON(json: any): CreatePresignedUrlRequest {
    return CreatePresignedUrlRequestFromJSONTyped(json, false);
}

export function CreatePresignedUrlRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePresignedUrlRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'target': json['target'],
        'fileName': json['fileName'],
    };
}

export function CreatePresignedUrlRequestToJSON(json: any): CreatePresignedUrlRequest {
    return CreatePresignedUrlRequestToJSONTyped(json, false);
}

export function CreatePresignedUrlRequestToJSONTyped(value?: CreatePresignedUrlRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'target': value['target'],
        'fileName': value['fileName'],
    };
}

